import React from 'react';
import {IzziHome} from "../components/home/IzziHome";

const HomePage = () => (
    <div>
        <IzziHome/>
    </div>
);

export default HomePage;